<template>
  <section>
    <ion-select v-if="showCompanies" 
      class="companySelect"
      v-model="companySelect" 
      :compare-with="compareWith" 
      :selectedText="`${(this.user.superAdmin) ? companySelect.M0_NOMECOM || companySelect.groupCompany + ' | ' : ''} ${ companySelect.M0_CODIGO } - ${ companySelect.M0_NOME } | ${companySelect.M0_CODFIL} - ${companySelect.M0_FILIAL}`"
      cancel-text="Cancelar"
      interface="action-sheet"
      :interface-options="{
        header: 'Seleção de Filial',
        subHeader: 'Filial'
      }"
      :style="{textAlign: 'left', paddingLeft: '10px'}">
      <ion-select-option
        v-for="company of companiesFiltered" :key="company" :value="company">
          <span v-if="this.user.superAdmin">{{ company.M0_NOMECOM || company.groupCompany }} | </span>
          <span>{{ company.M0_CODIGO }} - {{ company.M0_NOME }} | </span>
          {{company.M0_CODFIL}} - {{company.M0_FILIAL}}
      </ion-select-option>
    </ion-select>
  </section>
</template>

<script>
import { IonSelect, IonSelectOption } from '@ionic/vue'
import { createNamespacedHelpers, mapState, mapActions } from 'vuex'
import store from '../../store'
const { mapState:authState } = createNamespacedHelpers('auth')
export default {
  components: {
    IonSelect,
    IonSelectOption
  },
  name: 'SelectCompany',
  data: () => ({
    filter: '',
    companySelect: null
  }),
  watch: {
    companySelect(company) {
      this.changeCompany({company, user: this.user, $router: store.$router}) 
    }
  },
  computed: {
    ...mapState(['companies', 'companySelected']),
    ...authState(['user']),

    showCompanies() {
      return this.user.superAdmin || ((this.user && this.user.companies ) && (this.companies))
    },
    companiesFiltered() { 
      let sigamats = []
      const companies = Object.keys(this.companies).map(x => this.companies[x].sigamat)

      for (const c of companies) {
        sigamats.push(...c)
      }

      return sigamats.filter(sigamat => 
        !this.filter || (sigamat.filter(({groupCompany, M0_CODIGO, M0_CODFIL, M0_NOME, M0_FILIAL}) => 
          ( groupCompany, M0_CODIGO + M0_CODFIL + M0_NOME + M0_FILIAL).trim().toLowerCase().includes(this.filter.trim().toLowerCase()))
        )
      )
    }
  },
  methods: {
    ...mapActions(['changeCompany']),
    compareWith(o1, o2) {
      return o1.groupCompany + o1.M0_CODIGO + o1.M0_CODFIL === o2.groupCompany + o2.M0_CODIGO + o2.M0_CODFIL
    }
  },
  created() {
    this.companySelect = this.companySelected
  }
  
}
</script>

<style>
  ion-select.companySelect {
    font-size: .75em;
    box-shadow: .1em .1em .2em .1em rgba(0, 0, 0, 0.2);
    border-radius: 1em;
    margin: .25em;
  }

  button.action-sheet-button.select-interface-option {
    font-size: 1em;
    line-height: 1.5em;
    /* color: rgba(255, 255, 255, 0.8); */
    color: darkgrey!important;
    -webkit-text-fill-color: darkgrey!important;
    opacity: 1!important; /* required on iOS */
    border-bottom: 1px solid rgba(128, 128, 128, 0.1);
  }
</style>